<template>
  <!-- <div id="navBox"> -->
    <div id="navBox"  class="banner clearfix">
        <p hidden class="topIndex">{{ topIndex }}</p>
        <img src="@/assets/images/logo.png" class="block left bigLogo">
        <img src="@/assets/images/logo_mini.png" class="block left miniLogo">
        <ul class="left clearfix navList">
          <li
            v-for="item in data"
            :key="item.permName"
            @click="getChild"
            :class="item.permName"
          >
            <a :href="item.url">{{ item.permDesc }}</a>
          </li>
        </ul>
    </div>
  <!-- </div> -->
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      data: [{
        permName: "home",
        url: "/",
        permDesc: "征稿"
      },{
        permName: "shortlistPage",
        url: "/shortlistPage",
        permDesc: "入选名单"
      }],
    };
  },
  props: {
    topIndex: String,
  },
  mounted() {
    // 统一验证token
    
    var gettopIndex = $(".topIndex").text();
    setTimeout(function () {
      $.each($(".navList li"), function (index, obj) {
        var divClass = $(obj).prop("class");
        if (divClass == gettopIndex) {
          $(obj).addClass("navActive");
          $(obj).siblings().removeClass("navActive");
        }
      });
    }, 300);
  },
  methods: {
    getChild() {
      console.log(this.index);
    },
  },
};
</script>

<style>
/* 导航页css */

#navBox {
  width: calc(100% - 40px);
  height: 40px;
  padding: 10px 20px;
  overflow: hidden;
  top: 0;
  background-color: #fff;
  z-index: 20;
  margin-bottom: 50px;

}

#navBox ul {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-left: 100px;
}

#navBox li {
    line-height: 36px;
    float: left;
    font-size: 18px;
    font-weight: 700;
    padding: 0 20px;
}

#navBox li.navActive a{
  color: #cd2022;
  font-weight: bold;
}

#navBox .miniLogo{
  display: none;
}
@media (max-width: 600px) {
  #navBox .bigLogo{
    display: none;
  }
  #navBox .miniLogo{
    display: block;
    margin-left: 10px;
  }
  .navList {
    margin-left: 20px !important;
  }
}
</style>
